<template>
    <div class="list-container">
        <div class="header-bar" v-if="false">
            <button
                v-if="false"
                :title="$t('刷新列表')"
                @click="handleRefresh"
            >
                <i  class="el-icon-refresh-left" />
            </button>
        </div>
        <div class="scroll-container" v-if="conversationList">
            <template v-if="conversationList.length > 0">
                <v-conversation-item
                    v-for="item in conversationList"
                    :key="item.conversationID"
                    :conversation="item"
                />
            </template>
        </div>
    </div>
</template>

<script>
import ConversationItems from './ConversationItem.vue'
import { mapState } from 'vuex'

export default {
    name: 'ConverList',
    components: {
        'v-conversation-item': ConversationItems
    },
    data() {
        return {
            isCheckouting: false, // 是否正在切换会话
            timeout: null
        }
    },
    computed: {
        ...mapState({
            conversationList: state => state.timStore.conversationList,
            currentConversation: state => state.timStore.currentConversation
        })
    },
    methods: {
        handleRefresh() {
            console.log('当前会话列表===========================================')
            console.log(this.conversationList)
            this.refreshConversation()()
        },
        refreshConversation() {
            const that = this
            return function() {
                if (!that.timeout) {
                    that.timeout = setTimeout(() => {
                        that.timeout = null
                        that.$TIM.getConversationList().then(() => {
                            that.$message.success(that.$t('刷新成功'))
                        })
                    }, 1000)
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.list-container {
    width: 100%;
    height: 599px;
    display: flex;
    flex-direction: column;
    /* background: #363e47; */
    .header-bar {
        height: 53px;
        flex-shrink: 0;
        padding-right: 10px;
        button {
            float: right;
            display: inline-block;
            cursor: pointer;
            /* background: #303841; */
            border: none;
            color: #76828c;
            box-sizing: border-box;
            transition: .3s;
            user-select: none;
            margin: 0 10px 0 0;
            padding: 0;
            width: 30px;
            height: 30px;
            line-height: 34px;
            font-size: 24px;
            text-align: center;
            white-space: nowrap;
            border-radius: 50%;
            outline: 0;
            margin-top: 10px;
            &:hover {
                transform: rotate(360deg);
                color: #5cadff;
            }
        }
    }
    .scroll-container {
        // overflow-y: scroll;
        overflow-y: auto;
        border-right: 1px solid #e7e7e7;
        flex: 1;
    }

}

</style>
